import {
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  SvgIconProps,
} from '@mui/material';
import React from 'react';
import { Icon, IconTypes } from '../../icon/icon';

type IconListItemProps = {
  text: string;
  icon: IconTypes;
  styleType?: 'regular' | 'duotone' | 'custom';
  color?: SvgIconProps['color'];
};

const IconListItem = ({ text, icon, color, styleType }: IconListItemProps) => (
  <ListItem disableGutters sx={{ py: 0 }}>
    <ListItemIcon sx={{ minWidth: 32 }}>
      <Icon
        icon={icon}
        color={color || 'primary'}
        styleType={styleType || 'regular'}
        fontSize="small"
      />
    </ListItemIcon>
    <ListItemText primary={text} />
  </ListItem>
);

export type IconListProps = {
  listItems: IconListItemProps[];
  subheaderText?: string;
};

export const IconList = ({ listItems, subheaderText }: IconListProps) => (
  <List dense disablePadding>
    {subheaderText && (
      <ListSubheader disableGutters disableSticky sx={{ lineHeight: 1, mb: 2 }}>
        {subheaderText}
      </ListSubheader>
    )}
    {listItems.map(({ text, icon, color, styleType }, index) => (
      <React.Fragment key={index}>
        {index > 0 && <Divider sx={{ pt: 1, mb: 1 }} />}
        <IconListItem
          text={text}
          icon={icon}
          color={color}
          styleType={styleType}
        />
      </React.Fragment>
    ))}
  </List>
);
